module.exports = __webpack_public_path__ + "static/media/team-3.dcbe80f9.png";